import type ConversationReadingPaneViewState from "./schema/ConversationReadingPaneViewState";
import type ItemReadingPaneViewState from "./schema/ItemReadingPaneViewState";
import type ReadingPaneStore from "./schema/ReadingPaneStore";
import { registerMessageCacheReference } from "owa-mail-store/lib/store/messageCache";
import { registerConversationCacheReference } from "owa-mail-store/lib/store/conversationCache";
import { createStore } from "owa-satcheljs";
import type ReactionSkinTone from "owa-service/lib/contract/ReactionSkinTone";

const initialReadingPaneStore: ReadingPaneStore = {
    undoDarkModeByItemId: new Map<string, boolean>(),
    loadedItemReadingPaneViewStates: new Map<string, ItemReadingPaneViewState>([]),
    loadedConversationReadingPaneViewStates: new Map<string, ConversationReadingPaneViewState>([]),
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (17,5): Type 'null' is not assignable to type 'ItemReadingPaneViewState'.
    // @ts-expect-error
    itemPreviewPaneViewState: null,
    itemPrintPaneViewStates: new Map<string, ItemReadingPaneViewState>([]),
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (25,5): Type 'null' is not assignable to type 'DeeplinkId'.
    // @ts-expect-error
    deeplinkId: null,
    shouldShowMobileUpsellEmptyState: false,
    primaryReadingPaneTabId: null,
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (34,5): Type 'null' is not assignable to type 'string'.
    // @ts-expect-error
    sxsItemId: null, // used for conversation reading pane
    loadingProjectionIds: [],
    openPrintDialogTabIds: new Set<string>(),
    reactionsSkinTone: 0,
    hidePopout: false,
    blockScreenAPIExecuted: false,
};

export const getStore: () => ReadingPaneStore = createStore<ReadingPaneStore>("readingpane", initialReadingPaneStore);
export default getStore;

// Register the reading pane conversation with the conversation cache
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- Registration only queues the
 * reference getter until the cache is created after feature initialization. */
registerConversationCacheReference(() => [
    ...getStore().loadedConversationReadingPaneViewStates.keys(),
]);

/* eslint-disable-next-line owa-custom-rules/no-side-effects -- Registration only queues the
 * reference getter until the cache is created after feature initialization. */
registerMessageCacheReference(() => [
    ...getStore().loadedItemReadingPaneViewStates.keys(),
    ...Array.from(getStore().itemPrintPaneViewStates.values(), viewState => viewState.itemId),
    ...(getStore().itemPreviewPaneViewState?.itemId
        ? [getStore().itemPreviewPaneViewState.itemId]
        : []),
]);
